<template>
  <div v-if="data" class="vx-row w-full statistical-boxes m-0">
    <div
        :key="index"
        v-for="(data, index) in data"
        :class="cardWidth"
        class="statistical-box-wrapper pr-0"
    >
      <statistics-card-line
          hideChart
          :icon="data.icon"
          :statistic="data.value"
          :statisticTitle="data.label"
      >
      </statistics-card-line>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  components: {
    StatisticsCardLine
  },
  computed: {
    cardWidth() {
      const objCount = Object.keys(this.data).length;
      const cardBaseClass = 'vx-col w-full mb-base ';
      let cardClass = 'sm:w-1/' + objCount;

      if (objCount === 1) {
        cardClass = 'sm:w-full';
      }

      return cardBaseClass + cardClass;
    },
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
  .statistical-boxes {
    height: 82px;

    .statistical-box-wrapper {
      &:first-child {
        padding: 0;
      }
    }
  }
</style>
